import React from 'react';

import DialogWithWarningLayout from '@Containers/Dialogs/DialogsWithIcon/DialogWithWarningLayout';
import { headerString, zeroResultMEssage } from './ZeroFilterResultsConstants';


export default function ZeroFilterResults (props) {

  return (
    <DialogWithWarningLayout
      {...props}
      closeBtn={false}
      header={headerString}
    >
      {zeroResultMEssage}
    </DialogWithWarningLayout>
  );

}
